import { BsArrowBarDown, BsArrowBarUp } from 'react-icons/bs';
import { FC, useState } from 'react';
import { generalBlue } from 'src/app-config';
import { HTHDoNotCallsForm } from './HTHSectionFaceDoNotCallsForm';
import { HTHDoNotCallsItem } from './HTHSectionFaceDoNotCallsItem';
import { typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    currentFace: typeHTHFace;
    territoryNumber: typeTerritoryNumber;
};

export const HTHDoNotCalls: FC<propsType> = ({ currentFace, territoryNumber }) => {
    const [show, setShow] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const isMobile = useGetIsMobile();
    
    const closeShowFormHandler = (): void => setShowForm(false);

    return (
        <div style={{ marginTop: '100px', marginBottom: '50px' }}>
            <h1 className={'py-3 text-center text-white d-block mx-auto pointer rounded-3'}
                style={{
                    backgroundColor: !!currentFace.doNotCalls?.length ? generalBlue : 'gray',
                    marginBottom: '50px',
                    width: isMobile ? '100%' : '90%'
                }}
                onClick={() => setShow(x => !x)}
            >
                {!!currentFace.doNotCalls?.length ?
                    'NO TOCAR '
                    :
                    'No hay No Tocar en esta cara '
                }
                {show ?
                    <><BsArrowBarUp size={isMobile ? '1.6rem' : '1.4rem'} /></>
                    :
                    <><BsArrowBarDown size={isMobile ? '1.6rem' : '1.4rem'} /></>
                }
            </h1>
            {show &&
                <>
                {!!currentFace.doNotCalls?.length && currentFace.doNotCalls.map(doNotCall =>
                    <HTHDoNotCallsItem key={doNotCall.id}
                        currentFace={currentFace}
                        doNotCall={doNotCall}
                        territoryNumber={territoryNumber}
                    />
                )}
                <button className={'btn btn-general-blue btn-size12 d-block mx-auto'}
                    style={{ marginTop: '50px', width: '250px' }}
                    onClick={() => setShowForm(!showForm)}
                >
                    {showForm ? 'Ocultar' : 'Agregar No Tocar'}
                </button>
                {showForm &&
                    <HTHDoNotCallsForm
                        closeShowFormHandler={closeShowFormHandler}
                        currentFace={currentFace}
                        territoryNumber={territoryNumber}    
                    />
                }
                </>
            }
        </div>
    );
}
